/* Ange de Poche v2 : héros interactif (goupille, flash, 130 dB, relief), formules 1 / Duo / Pack, couleurs, commande directe */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NOM = { rose: 'Rose', noir: 'Noir', bleu: 'Bleu', blanc: 'Blanc' };
  var HEX = { rose: '#E7A3B4', noir: '#1D1B21', bleu: '#A9CCE3', blanc: '#F1F0EC' };
  var COL = ['rose', 'noir', 'bleu', 'blanc'];
  var MOTS = ['votre fille', 'votre mère', 'votre sœur', 'votre meilleure amie'];
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function parseMap(str, sep) {
    var o = {};
    (str || '').split(sep).forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) o[kv.slice(0, i)] = kv.slice(i + 1); });
    return o;
  }

  function init(hero) {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    var st = $('[data-adp-stage]', hero), prod = $('.adp-prod', st), tilt = $('.adp-prod__t', st);
    var cap = $('.adp-prod__cap', st), body = $('.adp-prod__body', st), gloss = $('.adp-prod__gloss', st);
    var e2 = $('.adp-e2', st), p3 = $$('.adp-p3 img', st), db = $('[data-adp-db]', hero), hint = $('.adp-hint', st);
    var dots = $$('.adp-dot', hero), sticky = hero.nextElementSibling && hero.nextElementSibling.nextElementSibling;
    if (!(sticky && sticky.hasAttribute('data-adp-sticky'))) sticky = null;
    var IM = {}, raw = parseMap(st.dataset.imgs, '|');
    Object.keys(raw).forEach(function (k) { var p = raw[k].split('~'); IM[k] = { full: p[0], cap: p[1], body: p[2] }; });
    var VMAP = parseMap(st.dataset.vmap, ';');
    var isProd = hero.classList.contains('adp-hero--produit');
    var q = 1, color = 'rose', sec = null, SL = ['rose', 'rose', 'noir', 'bleu'];
    var open = false, timer = null, raf = null, used = false;

    /* Taille de l'alarme : un carré qui tient dans la scène */
    function size() {
      var h = st.clientHeight, w = st.clientWidth, f = innerWidth >= 960 ? 0.9 : 1;
      var s = Math.round(Math.min(h * f, w));
      st.style.setProperty('--s', s + 'px');
    }
    size(); if ('ResizeObserver' in window) new ResizeObserver(size).observe(st); window.addEventListener('resize', size);

    /* Goupille : flash, ondes, compteur */
    function count() {
      var t0 = null; cancelAnimationFrame(raf);
      var DUR = 1100; db.textContent = '0';
      (function stp(ts) { t0 = t0 || ts; var p = Math.min((ts - t0) / DUR, 1); db.textContent = Math.round(130 * (1 - Math.pow(1 - p, 3))); if (p < 1) raf = requestAnimationFrame(stp); })(performance.now());
    }
    /* Sirène (Web Audio, sans fichier) : réglages copiés à l'identique de Ma Bulle Éclat (mb5.js) :
       carré 3000 Hz + dent de scie 3007 Hz, LFO triangle 7 Hz de ±650 Hz, passe-bas 5 kHz, volume .04. Jamais pendant la démo. */
    var actx = null, voice = null;
    function siren() {
      try {
        actx = actx || new (window.AudioContext || window.webkitAudioContext)();
        if (actx.state === 'suspended') actx.resume();
        var o = actx.createOscillator(), o2 = actx.createOscillator(), lfo = actx.createOscillator(), lg = actx.createGain(), g = actx.createGain(), f = actx.createBiquadFilter();
        o.type = 'square'; o2.type = 'sawtooth'; o.frequency.value = 3000; o2.frequency.value = 3007;
        lfo.type = 'triangle'; lfo.frequency.value = 7; lg.gain.value = 650;
        lfo.connect(lg); lg.connect(o.frequency); lg.connect(o2.frequency);
        f.type = 'lowpass'; f.frequency.value = 5000;
        o.connect(f); o2.connect(f); f.connect(g); g.connect(actx.destination);
        g.gain.setValueAtTime(0, actx.currentTime); g.gain.linearRampToValueAtTime(.04, actx.currentTime + .05);
        o.start(); o2.start(); lfo.start();
        voice = { o: [o, o2, lfo], g: g };
      } catch (e) {}
    }
    function hush() {
      var v = voice; voice = null; if (!v) return;
      try { v.g.gain.setTargetAtTime(0, actx.currentTime, .04); setTimeout(function () { v.o.forEach(function (x) { try { x.stop(); } catch (e) {} }); }, 250); } catch (e) {}
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) hush(); });
    function set(v, snd) {
      open = v; clearTimeout(timer);
      st.classList.toggle('is-open', v); hero.classList.toggle('is-alarm', v);
      if (v) { count(); if (snd) { siren(); try { document.dispatchEvent(new CustomEvent('adp:pull')); } catch (e) {} } timer = setTimeout(function () { set(false); }, 4000); } else { hush(); }
    }
    function user() { if (!used) { used = true; hint && hint.classList.remove('is-on'); } }
    function toggle() { user(); set(!open, true); }
    prod.addEventListener('click', toggle);
    prod.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });

    /* Relief : l'alarme suit la souris, le reflet glisse ; léger parallaxe au défilement */
    var tx = 0, ty = 0, cx = 0, cy = 0, vis = true, sp = 0;
    st.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = prod.getBoundingClientRect();
      tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
      ty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
    });
    st.addEventListener('pointerleave', function () { tx = 0; ty = 0; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; if (vis) kick(); }).observe(st);
    /* Vitesse (31/10) : sur téléphone la boucle ne tourne plus en continu (l'inclinaison n'existe qu'avec une souris),
       elle ne repart qu'au défilement ; --sp n'est réécrit que s'il change, sinon tout le haut de page est recalculé à chaque image. */
    var t = 0, fine = matchMedia('(hover: hover) and (pointer: fine)').matches, busy = false, lastSp = '';
    function frame() {
      busy = false;
      if (!vis || reduce) return;
      var more = fine;
      if (fine) {
        t += 0.012; cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        var ay = cx * 3.2 + Math.sin(t) * 1.2, ax = -cy * 1.8;
        tilt.style.transform = 'perspective(1400px) rotateY(' + ay.toFixed(2) + 'deg) rotateX(' + ax.toFixed(2) + 'deg)';
        tilt.style.setProperty('--lx', (50 + ay * 2.6).toFixed(1) + '%');
      }
      var hr = hero.getBoundingClientRect(), p = Math.max(0, Math.min(1, -hr.top / (hr.height || 1)));
      sp += (p - sp) * 0.2;
      if (Math.abs(p - sp) > 0.0005) more = true; else sp = p;
      var s4 = sp.toFixed(4);
      if (s4 !== lastSp) { lastSp = s4; hero.style.setProperty('--sp', s4); }
      if (more) kick();
    }
    function kick() { if (!busy) { busy = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', kick, { passive: true });
    st.addEventListener('pointermove', kick);
    kick();
    if (reduce) tilt.style.transform = 'none';

    /* Indice tant que personne n'a touché l'alarme (plus de démonstration automatique : le 130 dB n'apparaît qu'au tirage) */
    setTimeout(function () { if (!used && hint && !isProd) hint.classList.add('is-on'); }, 2300);
    setTimeout(function () { hint && hint.classList.remove('is-on'); }, 11000);

    /* Couleurs */
    setTimeout(function () { COL.forEach(function (c) { var m = IM[c]; if (m) [m.full, m.cap, m.body].forEach(function (u) { var i = new Image(); i.src = u; }); }); }, 1500);
    function paintProd(c) {
      var m = IM[c]; if (!m) return;
      cap.src = m.cap; body.src = m.body; gloss.style.setProperty('--m', 'url(' + m.full + ')');
    }
    function setE2(c, anim) {
      var m = IM[c]; if (!e2 || !m || e2.dataset.c === c) return;
      e2.dataset.c = c; clearTimeout(e2._t);
      if (!anim || q !== 2) { e2.src = m.full; e2.classList.remove('is-out'); return; }
      e2.classList.add('is-out');
      e2._t = setTimeout(function () { e2.src = m.full; e2.offsetWidth; setTimeout(function () { e2.classList.remove('is-out'); }, 40); }, 360);
    }
    var lastQ = 1;
    function paint(anim) {
      hero.classList.toggle('adp-q2', q === 2); hero.classList.toggle('adp-q4', q === 4);
      if (q !== lastQ) { lastQ = q; var pr = hero.querySelector('.adp-price.adp-q' + q + '-only'); if (pr && !reduce) { pr.classList.remove('adp-pop'); void pr.offsetWidth; pr.classList.add('adp-pop'); } }
      if (sticky) { sticky.classList.toggle('adp-q2', q === 2); sticky.classList.toggle('adp-q4', q === 4); sticky.style.setProperty('--c', HEX[color]); }
      $$('.adp-q__o', hero).forEach(function (o) { var on = +o.dataset.q === q; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on); });
      var s = sec || color;
      $$('.adp-q__c', hero).forEach(function (b) { b.classList.toggle('is-on', b.dataset.c === s); });
      SL[0] = color;
      $$('.adp-q__s', hero).forEach(function (b) { var c = SL[+b.dataset.k]; b.style.setProperty('--c', HEX[c]); b.setAttribute('aria-label', 'Alarme ' + (+b.dataset.k + 1) + ' : ' + NOM[c]); });
      p3.forEach(function (im, i) { var m = IM[SL[i + 1]]; if (m && im.getAttribute('src') !== m.full) im.src = m.full; });
      setE2(s, anim);
    }
    /* Désintégration (comportement relevé sur Ma Bulle Éclat, code écrit pour Ange de Poche) : l'ancienne couleur reste peinte
       sur un canevas au-dessus de la nouvelle et s'efface de haut en bas (820 ms, easeInOutQuad, bord fondu 2 x 7 %).
       À chaque ligne franchie, 7 grains carrés sont prélevés sur les vrais pixels de l'ancienne image : ils montent en accélérant
       et s'estompent (0,45 à 0,9 s). Le canevas est dans le relief : il penche avec l'alarme. */
    var dis = null, disRaf = 0, ROWS = {};
    function rowsOf(c, img) {
      if (ROWS[c]) return ROWS[c];
      var lw = 100, lh = Math.round(lw * img.naturalHeight / img.naturalWidth), sc = document.createElement('canvas'), out = [];
      sc.width = lw; sc.height = lh; var sx = sc.getContext('2d'); sx.drawImage(img, 0, 0, lw, lh);
      var d = null; try { d = sx.getImageData(0, 0, lw, lh).data; } catch (e) {}
      for (var y = 0; y < lh; y++) { var r = []; if (d) for (var x = 0; x < lw; x++) { var k = (y * lw + x) * 4; if (d[k + 3] > 120) r.push([x, d[k], d[k + 1], d[k + 2]]); } out.push(r); }
      out.lw = lw; out.ok = !!d; return (ROWS[c] = out);
    }
    function dissolve(oldC, done) {
      var m = IM[oldC]; if (!m) { done(); return; }
      var img = new Image(); img.src = m.full;
      function go() {
        if (dis) { cancelAnimationFrame(disRaf); dis.remove(); dis = null; }
        var W0 = tilt.offsetWidth, H0 = tilt.offsetHeight, dpr = Math.min(window.devicePixelRatio || 1, 2);
        var cw = W0 * 1.2, ch = H0 * 1.08, ox = W0 * 0.1, oy = H0 * 0.06, FE = .07;
        var cv = document.createElement('canvas'); cv.className = 'adp-dis'; cv.width = Math.round(cw * dpr); cv.height = Math.round(ch * dpr);
        tilt.appendChild(cv); dis = cv;
        var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
        var rows = rowsOf(oldC, img), lh = rows.length, lw = rows.lw, hx = HEX[oldC] || '#E7A3B4';
        done(); /* la nouvelle couleur est déjà dessous */
        var t0 = performance.now(), last = t0, P = [], lastRow = -1;
        (function frame(now) {
          var dt = Math.min(.033, (now - last) / 1000); last = now;
          var p = Math.min(1, (now - t0) / 820), e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2, f = -FE + e * (1 + 2 * FE);
          ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, cw, ch);
          if (p < 1) {
            ctx.drawImage(img, ox, oy, W0, H0);
            ctx.globalCompositeOperation = 'destination-out';
            var g = ctx.createLinearGradient(0, oy + (f - FE) * H0, 0, oy + (f + FE) * H0); g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.fillStyle = g; ctx.fillRect(0, 0, cw, oy + (f + FE) * H0);
            ctx.globalCompositeOperation = 'source-over';
          }
          for (var row = Math.max(0, Math.min(lh - 1, Math.floor(f * lh))), rr = lastRow + 1; rr <= row; rr++) {
            var line = rows[rr]; if (!line || !line.length) continue;
            for (var n = 0; n < 7; n++) {
              var q = line[Math.random() * line.length | 0];
              P.push({ x: ox + (q[0] + Math.random()) / lw * W0, y: oy + (rr + Math.random()) / lh * H0, vx: (Math.random() - .5) * 60, vy: -(30 + Math.random() * 80),
                l: 0, L: .45 + Math.random() * .45, c: rows.ok ? 'rgb(' + q[1] + ',' + q[2] + ',' + q[3] + ')' : hx, s: 1 + Math.random() * 1.8 });
            }
          }
          if (row > lastRow) lastRow = row;
          for (var i = P.length - 1; i >= 0; i--) {
            var d = P[i]; d.l += dt; if (d.l >= d.L) { P.splice(i, 1); continue; }
            d.vy -= 40 * dt; d.x += d.vx * dt; d.y += d.vy * dt;
            ctx.globalAlpha = Math.pow(1 - d.l / d.L, 1.5); ctx.fillStyle = d.c; ctx.fillRect(d.x, d.y, d.s, d.s);
          }
          ctx.globalAlpha = 1;
          if (p < 1 || P.length) disRaf = requestAnimationFrame(frame); else { cv.remove(); if (dis === cv) dis = null; }
        })(t0);
      }
      if (img.complete && img.naturalWidth) go(); else { img.onload = go; img.onerror = done; }
    }
    function pick(c) {
      if (!IM[c] || c === color) return;
      var prev = color, wasOpen = open;
      color = c; sec = null; if (open) set(false);
      try { document.dispatchEvent(new CustomEvent('adp:color', { detail: c })); } catch (e) {}
      dots.forEach(function (d) { var on = d.dataset.c === c; d.classList.toggle('is-on', on); d.setAttribute('aria-checked', on); });
      if (reduce) { paintProd(c); paint(false); return; }
      /* l'alarme ouverte se referme d'abord, puis l'ancienne couleur se désintègre */
      setTimeout(function () { if (color === c) dissolve(prev, function () { paintProd(c); }); }, wasOpen ? 450 : 0);
      paint(true);
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { user(); pick(d.dataset.c); }); });
    hero.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentNode;
      var o = t.closest('.adp-q__o'); if (o) { q = +o.dataset.q; paint(true); return; }
      var c = t.closest('.adp-q__c'); if (c) { sec = c.dataset.c; paint(true); return; }
      var sl = t.closest('.adp-q__s'); if (sl) { var k = +sl.dataset.k; SL[k] = COL[(COL.indexOf(SL[k]) + 1) % COL.length]; paint(false); return; }
    });
    hero._adpPick = pick;

    /* « une pour vous, une pour votre fille » : le mot change */
    var w = $('[data-adp-w]', hero), wi = 0;
    if (w) setInterval(function () { wi = (wi + 1) % MOTS.length; w.classList.add('is-out'); setTimeout(function () { w.textContent = MOTS[wi]; w.classList.remove('is-out'); }, 260); }, 2600);

    /* Commande directe : la bonne variante, puis le paiement */
    var root = hero.dataset.root || '/'; if (root.slice(-1) !== '/') root += '/';
    function variant() {
      var n = NOM[color], s = NOM[sec || color], props = null, id;
      if (q === 1) id = VMAP['1 Ange de Poche|' + n];
      else if (q === 2) {
        if (s === n) id = VMAP['Le Duo|' + n];
        else if ((n === 'Rose' && s === 'Noir') || (n === 'Noir' && s === 'Rose')) id = VMAP['Le Duo|Rose + Noir'];
        else { id = VMAP['Le Duo|' + n]; props = { '2e alarme': s }; }
      } else {
        var same = SL.every(function (c) { return c === SL[0]; });
        if (same) id = VMAP['Pack Famille|' + n];
        else { id = VMAP['Pack Famille|4 couleurs']; props = { 'Couleurs': SL.map(function (c) { return NOM[c]; }).join(', ') }; }
      }
      return { id: id, props: props };
    }
    function buy(btn) {
      var v = variant(); if (!v.id) { location.href = hero.dataset.purl; return; }
      btn && btn.classList.add('is-busy');
      var item = { id: +v.id, quantity: 1 }; if (v.props) item.properties = v.props;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) throw r; location.href = root + 'checkout'; })
        .catch(function () { location.href = root + 'cart/' + v.id + ':1'; });
    }
    $$('[data-adp-buy]', hero).forEach(function (b) { b.addEventListener('click', function () { buy(b); }); });
    if (sticky) {
      $$('[data-adp-buy]', sticky).forEach(function (b) { b.addEventListener('click', function () { buy(b); }); });
      var buyBox = $('.adp-buy', hero);
      if (buyBox && 'IntersectionObserver' in window) new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(buyBox);
    }
    window.addEventListener('pageshow', function () { $$('.adp-btn.is-busy').forEach(function (b) { b.classList.remove('is-busy'); }); });
    paint(false);
  }

  /* Colonne d'achat (section produit Talkie Kids) : couleurs façon Ma Bulle. Le sélecteur natif (caché) reçoit la bonne variante,
     les mélanges passent par les variantes « Rose + Noir » / « 4 couleurs » et des propriétés de panier, comme dans le héros. */
  function initChoix(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var sec = el.closest('section') || document;
    var color = 'rose', sec2 = null, SL = ['rose', 'noir', 'bleu', 'blanc'];
    function form() { return sec.querySelector('form[action*="/cart/add"]'); }
    function fieldset() { return sec.querySelectorAll('variant-selects fieldset')[1]; }
    function q() { var a = sec.querySelector('[data-sc-pack].is-active'); return a ? (+a.dataset.qty || 1) : 1; }
    function radio(val) { var f = fieldset(); if (!f) return null; return $$('input[type=radio]', f).filter(function (i) { return i.value === val; })[0]; }
    function target() {
      var n = NOM[color], s = NOM[sec2 || color], Q = q(), props = null, val = n;
      if (Q === 2) { if (s !== n) { if ((n === 'Rose' && s === 'Noir') || (n === 'Noir' && s === 'Rose')) val = 'Rose + Noir'; else props = { '2e alarme': s }; } }
      else if (Q === 4) { SL[0] = color; var same = SL.every(function (c) { return c === SL[0]; }); if (!same) { val = '4 couleurs'; props = { 'Couleurs': SL.map(function (c) { return NOM[c]; }).join(', ') }; } }
      return { val: val, props: props };
    }
    function paint() {
      var Q = q(); el.dataset.q = Q; SL[0] = color;
      $$('.adp-pd', el).forEach(function (b) { var on = b.dataset.c === color; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
      var cn = $('[data-adp-cn]', el); if (cn) cn.textContent = NOM[color];
      var s = sec2 || color;
      $$('.adp-q__c', el).forEach(function (b) { b.classList.toggle('is-on', b.dataset.c === s); });
      $$('.adp-q__s', el).forEach(function (b) { var c = SL[+b.dataset.k]; b.style.setProperty('--c', HEX[c]); b.setAttribute('aria-label', 'Alarme ' + (+b.dataset.k + 1) + ' : ' + NOM[c]); });
      var sum = $('[data-adp-sum]', el);
      if (sum) {
        if (Q === 2) { sum.hidden = false; sum.innerHTML = 'Vous recevez : <b>1 ' + NOM[color] + ' + 1 ' + NOM[s] + '</b>.'; }
        else if (Q === 4) { sum.hidden = false; sum.innerHTML = 'Vous recevez : <b>' + SL.map(function (c) { return NOM[c]; }).join(', ') + '</b>.'; }
        else sum.hidden = true;
      }
    }
    function apply() {
      paint();
      var t = target(), f = form();
      if (f) {
        $$('input[data-adp-prop]', f).forEach(function (i) { i.remove(); });
        if (t.props) Object.keys(t.props).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = t.props[k]; i.setAttribute('data-adp-prop', '1'); f.appendChild(i); });
      }
      var r = radio(t.val); if (r && !r.checked) r.click();
    }
    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentNode;
      var d = t.closest('.adp-pd'); if (d) { color = d.dataset.c; sec2 = null; apply(); try { document.dispatchEvent(new CustomEvent('adp:color', { detail: color })); } catch (x) {} return; }
      var c = t.closest('.adp-q__c'); if (c) { sec2 = c.dataset.c; apply(); return; }
      var sl = t.closest('.adp-q__s'); if (sl) { var k = +sl.dataset.k; SL[k] = COL[(COL.indexOf(SL[k]) + 1) % COL.length]; apply(); return; }
    });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-sc-pack]') && sec.contains(e.target)) setTimeout(apply, 60); });
    var f0 = fieldset(), ck = f0 && f0.querySelector('input[type=radio]:checked');
    if (ck) { var k0 = COL.filter(function (c) { return NOM[c] === ck.value; })[0]; if (k0) color = k0; }
    paint();
  }

  function all() { $$('[data-adp-hero]').forEach(init); $$('[data-adp-choix]').forEach(initChoix); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', all) : all();
  document.addEventListener('shopify:section:load', all);

  /* Fiche produit : la couleur choisie dans le formulaire change aussi l'alarme de démonstration */
  var MAP = { 'Rose': 'rose', 'Noir': 'noir', 'Bleu': 'bleu', 'Blanc': 'blanc', 'Rose + Noir': 'rose', '4 couleurs': 'rose' };
  document.addEventListener('change', function (e) {
    var el = e.target; if (!el || !el.name || el.name.indexOf('Couleur') !== 0) return;
    var c = MAP[el.value]; if (!c) return;
    $$('[data-adp-hero]').forEach(function (h) { if (h._adpPick) h._adpPick(c); });
  });
})();
